export const MenuList = [
  {
    title: "DOME",
    classChange: "mm-collapse",
    iconStyle: <i className="flaticon-093-waving" />,
    content: [
      {
        title: "Company",
        to: "company-list",
      },
      {
        title: "Host",
        to: "hosts",
      },
    ],
  },
  {
    title: "Admin",
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-025-dashboard"></i>,
    content: [
      {
        title: "Add Company",
        to: "dashboard",
      },
      {
        title: "All Tickets",
        to: "tickets",
      },
      {
        title: "Announcements",
        to: "announcements",
      },
    ],
  },
  {
    title: "mailing",
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-025-dashboard"></i>,
    content: [
      {
        title: "Companies",
        to: "dashboard/table",
      },
    ],
  },
];
